import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useLanguage } from '../../contexts/LanguageContext';

const FooterContainer = styled.footer`
  border-top: 1px solid ${props => props.theme.colors.lineFaint};
  padding: 32px 0 40px;
  margin-top: auto;
  background: ${props => props.theme.colors.bgPrimary};
`;

const FooterContent = styled.div`
  max-width: 960px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
`;

const Brand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const BrandMark = styled.span`
  font-family: ${props => props.theme.fonts.mono};
  font-size: 0.75rem;
  letter-spacing: 0.15em;
  color: ${props => props.theme.colors.starGold};
`;

const CopyText = styled.span`
  font-size: 0.72rem;
  color: ${props => props.theme.colors.textMuted};
  letter-spacing: 0.02em;
`;

const RightStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    align-items: center;
  }
`;

const LinkRow = styled.div`
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
  justify-content: flex-end;

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    justify-content: center;
  }
`;

const LegalLink = styled(Link)`
  font-size: 0.72rem;
  color: ${props => props.theme.colors.textMuted};
  text-decoration: none;
  transition: color 0.2s;

  &:hover { color: ${props => props.theme.colors.starGold}; }
`;

const Footer = () => {
  const { t } = useLanguage();

  return (
    <FooterContainer>
      <FooterContent>
        <Brand>
          <BrandMark>STRUCT CODE</BrandMark>
          <CopyText>© 2026 STRUCT CODE</CopyText>
        </Brand>
        <RightStack>
          <LinkRow>
            <LegalLink to="/legal/terms">{t('利用規約', 'Terms')}</LegalLink>
            <LegalLink to="/legal/privacy">{t('プライバシーポリシー', 'Privacy')}</LegalLink>
            <LegalLink to="/legal/tokushoho">{t('特定商取引法', 'Commercial Act')}</LegalLink>
          </LinkRow>
        </RightStack>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
